import { getNavItems } from './getNavItems';
import * as selectors from './selectors';

export default { getNavItems, ...selectors };
